

import { SituacaoParcelaEnum } from "../../classes/SituacaoParcelaEnum";
import { SituacaoPropostaEnum } from "../../classes/SituacaoPropostaEnum";

export default {
  name: 'tabela',
  props: {
    propostaParcelas: {
      type: Array,
      default: () => []
    },
    destinacao: {
      type: Object,
      default: null
    },
    situacaoProposta: {
      type: String,
      default: null
    }
  },
  computed: {
    qtdParcelas: function () {
      return this.destinacao.parcelas.length - 1
    }
  },
  data () {
    return {
      pagination: {
        sortBy: 'dataVencimento',
        descending: false,
        rowsPerPage: 0
      },
      situacaoParcelaEnum: SituacaoParcelaEnum,
      situacaoPropostaEnum: SituacaoPropostaEnum,
      columns: [
        { name: 'numeroParcela', label: 'N. Parc.', field: row => row.numeroParcela, sortable: false },
        { name: 'dataVencimento', label: 'Vencimento', field: row => row.dataVencimento, sortable: true },
        { name: 'situacao', label: 'Situação', field: row => row.situacao, sortable: false },
        { name: 'porcentagemPrincipal', label: '% Principal', field: row => row.porcentagemPrincipal.toFixed(2), sortable: false },
        { name: 'porcentagemJuros', label: '% Juros', field: row => row.porcentagemJuros.toFixed(2), sortable: false },
      ]
    }
  }
}
